/**
 * Best-effort navigation for federated timeline `deep_link` values.
 * The SPA is mode-based; this assigns the path (Vercel rewrites to index.html)
 * so devs can bookmark / share the target URL.
 */
export function navigateActivityDeepLink(link: string | null): boolean {
  if (!link || !link.trim()) return false;
  try {
    const url = new URL(link.trim(), window.location.origin);
    window.location.assign(url.pathname + url.search + url.hash);
    return true;
  } catch {
    return false;
  }
}

export async function copyTimelineStableId(id: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(id);
    return true;
  } catch {
    return false;
  }
}
